<template>
  <div class="video-guide-drawer">
    <el-button class="video-guide-trigger-btn" @click="drawerVisible = true">
      <svg-icon color="#C38000" icon-class="play-yellow" />
      <span>{{ triggerBtnLabel }}</span>
    </el-button>

    <el-drawer
      :visible.sync="drawerVisible"
      :show-close="false"
      size="472px"
      :direction="drawerDirection"
    >
      <template v-slot:title>
        <div class="flex">
          <el-button
            type="text"
            class="close-drawer-btn py-2"
            @click="drawerVisible = false"
          >
            <el-icon class="el-icon-error" />
          </el-button>
        </div>
      </template>
      <div class="px-5">
        <el-collapse v-model="activeIdx" accordion>
          <template v-for="(vid, index) in videos">
            <el-collapse-item
              :key="index"
              :disabled="videos.length === 1"
              :name="index"
            >
              <template slot="title">
                <h3 class="font-semibold leading-8 text-2xl">
                  {{ $t(vid.title) }}
                </h3>
                <template v-if="videos.length > 1">
                  <svg-icon v-if="index === activeIdx" icon-class="minus" />
                  <svg-icon v-else icon-class="plus" />
                </template>
              </template>
              <!-- If we don't put v-if here, when we close the modal, the video sound will keep on playing -->
              <iframe
                v-if="drawerVisible"
                class="overflow-hidden rounded-xl"
                width="432"
                height="315"
                :src="$t(vid.videoLink)"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              />
              <p class="video-guide-desc text-sm font-normal">
                {{ $t(vid.description) }}
              </p>
            </el-collapse-item>
          </template>
        </el-collapse>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VideoGuideDrawer',
  props: {
    // videos should be an array of object that hav
    // + title
    // + description
    // + videoLink: currently expected youtube link for embedded, will need to implement more if needed to support more format
    videos: {
      type: Array,
      default: () => [],
    },
    triggerBtnLabel: {
      type: String,
      default: function() {
        return this.$t('tutorial_trigger_text')
      },
    },
  },
  data() {
    return {
      drawerVisible: false,
      activeIdx: null,
    }
  },
  computed: {
    ...mapGetters('translations', ['currentLocale']),
    drawerDirection() {
      return this.currentLocale === 'en_US' ? 'rtl' : 'ltr'
    },
  },
  watch: {
    drawerVisible(isVisible) {
      if (isVisible) {
        this.activeIdx = 0
      }
    },
  },
  methods: {
    openDrawer() {
      this.drawerVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.video-guide-drawer ::v-deep {
  .el-collapse {
    border: none;
  }

  .el-drawer__header {
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
  }

  .el-drawer__body {
    overflow: auto;
  }

  .close-drawer-btn {
    &,
    &:hover,
    &:active {
      margin-inline-start: auto;
      font-size: 20px;
      color: #000;
      border: none;
      outline: none;
    }
  }

  .el-collapse-item__header {
    justify-content: space-between;
    height: auto;
    padding: 24px 0;

    svg {
      width: 14px;
      height: 14px;
      fill: #666;
    }
  }

  .el-collapse-item__arrow {
    display: none;
  }
}

.video-guide-trigger-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  &,
  &:focus,
  &:hover {
    color: #c38000;
    background: rgba(239, 169, 28, 0.1);
    border: none;
    border-radius: 9999px;
    outline: none;

    svg {
      filter: none;
    }
  }

  svg {
    width: 24px;
    height: 24px;
    margin-inline-end: 4px;
  }

  ::v-deep & > span {
    display: flex;
    align-items: center;
    font-family: 'Helvetica Neue', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}

h3 {
  [dir='ltr'] & {
    font-family: 'Space Grotesk', sans-serif;
  }

  [dir='rtl'] & {
    font-family: 'IBM Plex Sans Arabic', sans-serif;
  }

  color: #000;
}

iframe {
  margin-block-end: 18px;
}

.video-guide-desc {
  font-family: 'Helvetica Neue', sans-serif;
  line-height: 22px;
  color: #666;
}
</style>
